<template>
  <div
    ref="root"
    class="animated-section"
    :class="{ 'is-visible': isVisible, 'is-left': direction === 'left', 'is-right': direction === 'right' }"
    :style="{ transitionDelay: delay + 'ms' }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AnimatedSection',
  props: {
    className: { type: String, default: '' },
    delay: { type: Number, default: 0 },
    direction: { type: String, default: 'up' },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.isVisible = true;
          this.observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );
    if (this.$refs.root) {
      this.observer.observe(this.$refs.root);
    }
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>

<style lang="less" scoped>
.animated-section {
  opacity: 0;
  transform: translateY(32px);
  transition: all 0.7s ease-out;

  &.is-left {
    transform: translateX(-32px);
  }

  &.is-right {
    transform: translateX(32px);
  }

  &.is-visible {
    opacity: 1;
    transform: translate(0, 0);
  }
}
</style>
